/* eslint-disable react-hooks/exhaustive-deps */
import {
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from "@mui/material";
import { submitRequestDialogStyles as styles } from "../../styles";
import MultiSelect from "../../../../components/MultiSelect";

const CloudSpecificItem = ({ payload, setPayload, cloud, getEnvsResp }) => {
  return (
    <>
      <Grid item xs={2}>
        <FormControlLabel
          sx={{ mt: "5px" }}
          control={
            <Switch
              color="secondary"
              value={payload?.clouds?.[cloud]}
              onChange={(e) => {
                setPayload((prev) => {
                  if (prev?.clouds?.[cloud]) {
                    const curr = structuredClone(prev);
                    delete curr?.clouds?.[cloud];
                    return curr;
                  } else {
                    return {
                      ...prev,
                      clouds: { ...prev?.clouds, [cloud]: {} },
                    };
                  }
                });
              }}
            />
          }
          label={cloud}
        />
      </Grid>
      {payload?.clouds?.[cloud] ? (
        <>
          <Grid item xs={4}>
            <FormControl sx={styles.formControl}>
              <InputLabel size="string" color="secondary">
                Tenant
              </InputLabel>
              <Select
                fullWidth
                label={"Tenant"}
                color="secondary"
                value={payload?.clouds?.[cloud]?.tenantDomain}
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    clouds: {
                      ...prev?.clouds,
                      [cloud]: {
                        ...prev.clouds?.[cloud],
                        tenantDomain: e.target.value,
                      },
                    },
                  }));
                }}
              >
                {getEnvsResp?.response
                  ?.filter((tenant) => tenant?.status === "RUNNING")
                  .map((tenant, i) => (
                    <MenuItem value={tenant?.url} key={i}>
                      {tenant?.url}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <MultiSelect
              label="Db Software"
              setSelectedItems={(newVal) => {
                setPayload((prev) => ({
                  ...prev,
                  clouds: {
                    ...prev?.clouds,
                    [cloud]: {
                      ...prev?.clouds?.[cloud],
                      dbSoftware: newVal,
                    },
                  },
                }));
              }}
              limit={1}
              // sx={requestCPDialogStyles.multiSelect}
              sx={{ minWidth: "10%" }}
              populateItemsWhenEmpty={false}
              allItems={payload?.dbSoftware
                ?.filter((dbSoftware) =>
                  dbSoftware?.cloudsList?.includes(cloud)
                )
                ?.map(
                  (dbSoftware) =>
                    `${dbSoftware?.patchVersionName} {${dbSoftware?.majorVersion}}`
                )}
            />
          </Grid>
        </>
      ) : (
        <Grid item xs={10}></Grid>
      )}
    </>
  );
};

export default CloudSpecificItem;
